import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, daigakuFeatureKey } from '../reducers/daigaku.reducer';

const selectDaigakuState = createFeatureSelector<State>(daigakuFeatureKey);

export const getDaigaku = createSelector(selectDaigakuState, state => state.daigaku);
export const getDaigakus = createSelector(selectDaigakuState, state => state.daigakus);
export const getCreateDaigakuResult = createSelector(selectDaigakuState, state => state.createDaigakuResult);
export const getUpdateDaigakuResult = createSelector(selectDaigakuState, state => state.updateDaigakuResult);
export const getDeleteDaigakuResult = createSelector(selectDaigakuState, state => state.deleteDaigakuResult);
